(function () {
    "use strict";

    angular.module("app").factory('dossierService', DossierServiceFactory);
    DossierServiceFactory.$inject = ['$http', 'settingsService',];
    function DossierServiceFactory($http, settingsService) {

        return {
            currentTab: 'info',
            searchPerson: searchPerson,
            searchPersonOrganisation: searchPersonOrganisation,
            searchOrganisationPerson: searchOrganisationPerson,
        };

        function createRequest(payload, endpoint) {
            return $http({
                method: "post",
                url: settingsService.applicationPath + endpoint,
                data: payload
            });
        }

        function searchPerson(dossierId, successCallback, errorCallback) {
            createRequest({ PublicId: dossierId }, "api/Dossier/Person")
                .then(
                    function (result, status, headers, config) {
                        successCallback(result.data, status, headers, config);
                    },
                    function (result, status, headers, config) {
                        errorCallback(result.data, status, headers, config);
                    });
        }

        function searchPersonOrganisation(dossierId, successCallback, errorCallback) {
            createRequest({ PublicId: dossierId }, "api/Dossier/PersonOrganisation")
                .then(
                    function (result, status, headers, config) {
                        successCallback(result.data, status, headers, config);
                    },
                    function (result, status, headers, config) {
                        errorCallback(result.data, status, headers, config);
                    });
        }

        function searchOrganisationPerson(dossierId, successCallback, errorCallback) {
            createRequest({ PublicId: dossierId }, "api/Dossier/OrganisationPerson")
                .then(
                    function (result, status, headers, config) {
                        successCallback(result.data, status, headers, config);
                    },
                    function (result, status, headers, config) {
                        errorCallback(result.data, status, headers, config);
                    });
        }
    }
})();

